import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Addresses_DatasourceService } from './Addresses.datasource.index';
import { Carriers_DatasourceService } from './Carriers.datasource.index';
import { Materials_DatasourceService } from './Materials.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';
import { InventoryCounts_DatasourceService } from './InventoryCounts.datasource.index';
import { PrintNode_DatasourceService } from './PrintNode.datasource.index';
import { WorkOrders_DatasourceService } from './WorkOrders.datasource.index';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { Reports_DatasourceService } from './Reports.datasource.index';
import { FootprintApiManager_DatasourceService } from './FootprintApiManager.datasource.index';

import { app_custom_ds_find_status_change_task_for_lotService } from './app.datasource.index';
import { app_custom_ds_get_all_projectsService } from './app.datasource.index';
import { app_custom_ds_get_count_tasks_detailsService } from './app.datasource.index';
import { app_custom_ds_get_licenseplates_by_shipmentIdService } from './app.datasource.index';
import { app_custom_ds_get_location_udfsService } from './app.datasource.index';
import { app_custom_ds_get_locations_by_warehouse_idService } from './app.datasource.index';
import { app_custom_ds_get_materials_for_dnspService } from './app.datasource.index';
import { app_custom_ds_get_operationcode_by_nameService } from './app.datasource.index';
import { app_custom_ds_get_vendor_lots_for_dnspService } from './app.datasource.index';
import { app_custom_ds_lp_count_by_project_warehouseService } from './app.datasource.index';
import { app_custom_get_completed_orders_without_attachmentService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Addresses = this.injector.get(Addresses_DatasourceService);
    this.Carriers = this.injector.get(Carriers_DatasourceService);
    this.Materials = this.injector.get(Materials_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
    this.InventoryCounts = this.injector.get(InventoryCounts_DatasourceService);
    this.PrintNode = this.injector.get(PrintNode_DatasourceService);
    this.WorkOrders = this.injector.get(WorkOrders_DatasourceService);
    this.SalesOrders = this.injector.get(SalesOrders_DatasourceService);
    this.Invoices = this.injector.get(Invoices_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.Reports = this.injector.get(Reports_DatasourceService);
    this.FootprintApiManager = this.injector.get(FootprintApiManager_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
    public Addresses: Addresses_DatasourceService;
    public Carriers: Carriers_DatasourceService;
    public Materials: Materials_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public Inventory: Inventory_DatasourceService;
    public InventoryCounts: InventoryCounts_DatasourceService;
    public PrintNode: PrintNode_DatasourceService;
    public WorkOrders: WorkOrders_DatasourceService;
    public SalesOrders: SalesOrders_DatasourceService;
    public Invoices: Invoices_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public Reports: Reports_DatasourceService;
    public FootprintApiManager: FootprintApiManager_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_ds_find_status_change_task_for_lot: app_custom_ds_find_status_change_task_for_lotService;
  public get custom_ds_find_status_change_task_for_lot(): app_custom_ds_find_status_change_task_for_lotService {
    if(!this._custom_ds_find_status_change_task_for_lot) {
      this._custom_ds_find_status_change_task_for_lot = this.injector.get(app_custom_ds_find_status_change_task_for_lotService);
    }
    return this._custom_ds_find_status_change_task_for_lot;
  }
  private _custom_ds_get_all_projects: app_custom_ds_get_all_projectsService;
  public get custom_ds_get_all_projects(): app_custom_ds_get_all_projectsService {
    if(!this._custom_ds_get_all_projects) {
      this._custom_ds_get_all_projects = this.injector.get(app_custom_ds_get_all_projectsService);
    }
    return this._custom_ds_get_all_projects;
  }
  private _custom_ds_get_count_tasks_details: app_custom_ds_get_count_tasks_detailsService;
  public get custom_ds_get_count_tasks_details(): app_custom_ds_get_count_tasks_detailsService {
    if(!this._custom_ds_get_count_tasks_details) {
      this._custom_ds_get_count_tasks_details = this.injector.get(app_custom_ds_get_count_tasks_detailsService);
    }
    return this._custom_ds_get_count_tasks_details;
  }
  private _custom_ds_get_licenseplates_by_shipmentId: app_custom_ds_get_licenseplates_by_shipmentIdService;
  public get custom_ds_get_licenseplates_by_shipmentId(): app_custom_ds_get_licenseplates_by_shipmentIdService {
    if(!this._custom_ds_get_licenseplates_by_shipmentId) {
      this._custom_ds_get_licenseplates_by_shipmentId = this.injector.get(app_custom_ds_get_licenseplates_by_shipmentIdService);
    }
    return this._custom_ds_get_licenseplates_by_shipmentId;
  }
  private _custom_ds_get_location_udfs: app_custom_ds_get_location_udfsService;
  public get custom_ds_get_location_udfs(): app_custom_ds_get_location_udfsService {
    if(!this._custom_ds_get_location_udfs) {
      this._custom_ds_get_location_udfs = this.injector.get(app_custom_ds_get_location_udfsService);
    }
    return this._custom_ds_get_location_udfs;
  }
  private _custom_ds_get_locations_by_warehouse_id: app_custom_ds_get_locations_by_warehouse_idService;
  public get custom_ds_get_locations_by_warehouse_id(): app_custom_ds_get_locations_by_warehouse_idService {
    if(!this._custom_ds_get_locations_by_warehouse_id) {
      this._custom_ds_get_locations_by_warehouse_id = this.injector.get(app_custom_ds_get_locations_by_warehouse_idService);
    }
    return this._custom_ds_get_locations_by_warehouse_id;
  }
  private _custom_ds_get_materials_for_dnsp: app_custom_ds_get_materials_for_dnspService;
  public get custom_ds_get_materials_for_dnsp(): app_custom_ds_get_materials_for_dnspService {
    if(!this._custom_ds_get_materials_for_dnsp) {
      this._custom_ds_get_materials_for_dnsp = this.injector.get(app_custom_ds_get_materials_for_dnspService);
    }
    return this._custom_ds_get_materials_for_dnsp;
  }
  private _custom_ds_get_operationcode_by_name: app_custom_ds_get_operationcode_by_nameService;
  public get custom_ds_get_operationcode_by_name(): app_custom_ds_get_operationcode_by_nameService {
    if(!this._custom_ds_get_operationcode_by_name) {
      this._custom_ds_get_operationcode_by_name = this.injector.get(app_custom_ds_get_operationcode_by_nameService);
    }
    return this._custom_ds_get_operationcode_by_name;
  }
  private _custom_ds_get_vendor_lots_for_dnsp: app_custom_ds_get_vendor_lots_for_dnspService;
  public get custom_ds_get_vendor_lots_for_dnsp(): app_custom_ds_get_vendor_lots_for_dnspService {
    if(!this._custom_ds_get_vendor_lots_for_dnsp) {
      this._custom_ds_get_vendor_lots_for_dnsp = this.injector.get(app_custom_ds_get_vendor_lots_for_dnspService);
    }
    return this._custom_ds_get_vendor_lots_for_dnsp;
  }
  private _custom_ds_lp_count_by_project_warehouse: app_custom_ds_lp_count_by_project_warehouseService;
  public get custom_ds_lp_count_by_project_warehouse(): app_custom_ds_lp_count_by_project_warehouseService {
    if(!this._custom_ds_lp_count_by_project_warehouse) {
      this._custom_ds_lp_count_by_project_warehouse = this.injector.get(app_custom_ds_lp_count_by_project_warehouseService);
    }
    return this._custom_ds_lp_count_by_project_warehouse;
  }
  private _custom_get_completed_orders_without_attachment: app_custom_get_completed_orders_without_attachmentService;
  public get custom_get_completed_orders_without_attachment(): app_custom_get_completed_orders_without_attachmentService {
    if(!this._custom_get_completed_orders_without_attachment) {
      this._custom_get_completed_orders_without_attachment = this.injector.get(app_custom_get_completed_orders_without_attachmentService);
    }
    return this._custom_get_completed_orders_without_attachment;
  }
}

